export default __webpack_public_path__ + "static/media/map-type-satellite-with-labels.38dbe600.png";